module.exports = __webpack_public_path__ + "img/2_193.6ad72c71.png";